export default __webpack_public_path__ + "static/media/links.4bfdcc20.svg";